import * as isEmpty from 'lodash.isempty';

export default {
  name: 'ProductSourceProductSourceSettings',
  props: ['productSource', 'translations'],
  methods: {
    change(name, value) {
      this.$emit(
        'change',
        this.productSource.display_id,
        this.productSource.arguments.map(argument => (argument.name === name ? { name, value } : argument))
      );
    }
  },
  computed: {
    isItShown() {
      return !isEmpty(this.productSource.arguments);
    }
  }
};
